import styled, { css } from 'styled-components';

const prefixModifier = ({ isPrefix }) => isPrefix && css`
  padding: 0 16px 0 20px;
`;

const suffixModifier = ({ isSuffix }) => isSuffix && css`
  padding: 0 20px 0 16px;
`;

export default styled.button`
  line-height: 1;
  background: none;
  border: none;
  height: 100%;
  cursor: pointer;
  ${suffixModifier}
  ${prefixModifier}
`;

